// Webinar configuration
export const WEBINAR_DATE = "May 3, 2026";
export const WEBINAR_DATE_SHORT = "May 3rd";
export const WEBINAR_DAY = "Sunday";
export const WEBINAR_TIME = "3:00 PM IST";
export const WEBINAR_TIME_RANGE = "3:00 – 4:30 PM IST";
export const WEBINAR_DURATION = "90 minutes";
export const WEBINAR_DATETIME_ISO = "2026-05-03T15:00:00+05:30";
export const WEBINAR_END_DATETIME_ISO = "2026-05-03T16:30:00+05:30";
export const WEBINAR_DATETIME = new Date(WEBINAR_DATETIME_ISO);

// Kept for backwards compatibility with any unmodified files
export const BATCH_DATE = WEBINAR_DATE;
export const BATCH_DATE_ISO = "2026-05-03";
